
import defaultboy from '../../assets/user.png'
import React, { useState } from 'react'
import axios from 'axios'
import ENDPOINT from '../../data/ENDPOINT'
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import { Link, useParams } from 'react-router-dom';
import {useEffect} from 'react'
import Localbase from 'localbase';
import UserProfileBasic from '../account/UserProfileBasic';
import ConnectionsList from './ConnectionsList';
import UserAccount from '../account/UserAccount';
import ConnectionItem from './ConnectionItem';
import ConnectionsTemplate from './ConnectionsTemplate';
import SetPage from '../../data/SetPage';
import { CircularProgress } from '@mui/material';
import { Helmet } from 'react-helmet';
import FetchFingerprint from '../../actions/FetchFingerprint';
const FollowersPage = ({post,account,access}) => {
const params = useParams()
const type = params.type;
const {user}= useContext(AuthContext)

useEffect(()=>{
SetPage("Followers")
},[])

const [connections,setconnections] = useState(null)
let db = new Localbase("db")
    const getConnections = async (account)=>{
        
setloading(true)
        const formData = new FormData();
        formData.append('session',user.SessionId)
        formData.append("fp",FetchFingerprint());
        
          formData.append('type',type);
        
        
        const res = await axios.post(ENDPOINT+"followers.php", formData,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        });
        if(res){
            setloading(false)
        //  //console.log("conn "+JSON.stringify(res))
         if(res.data.status==="success" && res.data.followers!==null){
setconnections(res.data.followers)
db.collection("paths").add({
    followers:res.data.followers
},"followers")
         }
         else if(res.data.status==="success" && res.data.data===null){
      
         }
        }
        }




useEffect(()=>{
   // //  //  //console.log("getting conn")
   db.collection("paths").doc("followers").get().then(data=>{
    setconnections(data.followers)
}).catch(error=>{

})



getConnections()

},[type])









const [loading,setloading] = useState(false)

const startConversation = async ({status,receiver_id,initial_id,e})=>{
    sessionStorage.setItem('cid',initial_id)




                const formData = new FormData();
                
                
                //formData.append('whyus',document.getElementById('whyus').value)
                
                formData.append('session',user[0].SessionId);
      
               formData.append('receiver_id',receiver_id);
             
                const res = await axios.post(ENDPOINT+"start-conversation.php", formData,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                if(res){
                   if(res.data.status==="success"){
                     

                 // //  //  //console.log("conversation started");
                 }
                 else{
                
                 }
                }
                }








                const updateConnection = async (status,connection)=>{
             
     
                    const formData = new FormData();
                    
                    
                    //formData.append('whyus',document.getElementById('whyus').value)
                    
                    formData.append('session',user[0].SessionId);
                    
                      formData.append('id',connection.id);
                      formData.append('status',"accepted");
                    
                    const res = await axios.post(ENDPOINT+"update-connection-request.php", formData,{
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    });
                    if(res){
                      if(res.data.status==="success"){
                
                     }
                     else if(res.data.status==="error"){
                     
                     }
                    }
                    }
               

    return (
        <>
<ConnectionsTemplate>
<Helmet>‍
        <title>Followers - Skills Uprise</title>‍
        <meta name="description" content="Skills Uprise" />       
        <meta name="twitter:card" content="" />   
        <meta name="twitter:site" content="@skillsuprise" />    
        <meta name="twitter:creator" content="@skillsuprise" />                
        <meta name="twitter:title" content="" />   
        <meta name="twitter:description" content="" />  
        <meta name="twitter:image" content=""/>     
        <meta property="og:title" content="" />  
        <meta property="og:description" content="" />        
        <meta property="og:image" content=""/>
        <meta property="og:url" content=""/>
        <meta property="og:site_name" content="Skills Uprise" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="fb:app_id" content="ID_APP_FACEBOOK" />
      </Helmet>
<div className="col-lg-8 col-md-8 col-sm-12 col-12">
<div className=" grid-2 sm-grid-4 grid-sm-3  grid lg-grid-5">

{connections?
<>
<ConnectionsList connections={connections} access={access}/>

</>:<>

</>}


</div>



{connections?
<>

</>:<>


<div className="w-100 justify-content-center d-flex pt-5">

{loading?
<>
<div className="grid text-center justify-content-center  mb-5">

<CircularProgress/>

</div>


</>:
<>
<div className="col-lg-7 text-center">
<h4>No Followers</h4>
<p>Register a course to connect with students from various colleges across the globe.</p>

</div>
</>}


</div>


</>}
</div>
 
</ConnectionsTemplate>
        
        </>
    )
}

export default FollowersPage
